import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CreateRaffle from "./components/CreateRaffle";
import RaffleList from "./components/RaffleList";
import RafflesPublicDetails from "./views/RafflesPublicDetails";
import RafflesAdminDetails from "./views/RafflesAdminDetails";
import Login from "./views/auth/Login";
import Home from "./views/dashboard/ListRaffles";
import Landing from "./views/LandingPage";
import SignUp from "./views/auth/SignUp";
import TermsConditions from "./views/auth/TermsConditions";
import { Navigate } from 'react-router-dom';
import { authFB } from './firebase'; 
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import NotFound from "./views/NotFound";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authFB, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return { user, loading };
};

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

function App() {

  return (
    <Router>
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/" element={<Login />} />
      <Route path="/terms-conditions" element={<TermsConditions />} />

      {/* Rutas privadas */}
      <Route path="/raffles" element={
        <PrivateRoute>
          <Home />
        </PrivateRoute>
      } />
      <Route path="/create" element={
        <PrivateRoute>
          <CreateRaffle />
        </PrivateRoute>
      } />
      <Route path="/raffles/:id" element={
        <PrivateRoute>
          <RafflesAdminDetails />
        </PrivateRoute>
      } />

      {/* Ruta pública de detalles de rifas */}
      <Route path="/raffles/public/:id" element={<RafflesPublicDetails />} />

      {/* Ruta para manejar rutas no encontradas */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Router>
  );
}

export default App;
